var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { height: "100%" } }, [
    _vm.job.vgmChannel === 1 || _vm.isWse || _vm.isRongETong
      ? _c(
          "div",
          { staticStyle: { height: "100%" } },
          [
            _c("sea-house-vgm", {
              ref: "seaHouseVgm",
              attrs: {
                job: _vm.job,
                "vas-channel": _vm.vasChannel,
                readonly: _vm.readonly,
                "is-edit": _vm.isEdit
              },
              on: { syncData: _vm.syncData }
            })
          ],
          1
        )
      : _vm._e(),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.job.vgmChannel === 0,
            expression: "job.vgmChannel === 0"
          }
        ],
        staticClass: "tab-vgm",
        staticStyle: { "margin-top": "10px", width: "100%" }
      },
      [
        _c(
          "div",
          {
            staticClass: "section",
            staticStyle: {
              width: "100%",
              "padding-top": "10px",
              "margin-left": "0px"
            }
          },
          [
            _c(
              "div",
              { staticStyle: { display: "flex" } },
              [
                _c(
                  "span",
                  { staticClass: "title", staticStyle: { width: "100px" } },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_VGMChannel")) + "：")]
                ),
                _c(
                  "el-radio-group",
                  {
                    staticStyle: { width: "100%" },
                    attrs: { disabled: _vm.readonly },
                    on: { change: _vm.changeLocalVgmChannel },
                    model: {
                      value: _vm.localVgmChannel,
                      callback: function($$v) {
                        _vm.localVgmChannel = $$v
                      },
                      expression: "localVgmChannel"
                    }
                  },
                  _vm._l(_vm.vgmChannels, function(option) {
                    return _c(
                      "el-radio",
                      { key: option.code, attrs: { label: option.code } },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.isZh ? option.chineseName : option.englishName
                          )
                        )
                      ]
                    )
                  }),
                  1
                )
              ],
              1
            )
          ]
        ),
        _c(
          "div",
          [
            _c("div", { staticStyle: { display: "flex" } }, [
              _c(
                "div",
                {
                  staticClass: "section",
                  staticStyle: { width: "250px", flex: "none" }
                },
                [
                  _c("cargo-ag-grid", {
                    staticStyle: { width: "100%", height: "350px" },
                    attrs: {
                      no: "1",
                      "grid-options": _vm.left.gridOptions,
                      "grid-params": _vm.left.gridParams,
                      "column-defs": _vm.leftColumnDefs,
                      "row-data": _vm.vgms
                    },
                    on: {
                      "update:gridParams": function($event) {
                        return _vm.$set(_vm.left, "gridParams", $event)
                      },
                      "update:grid-params": function($event) {
                        return _vm.$set(_vm.left, "gridParams", $event)
                      },
                      gridReady: function(params) {
                        _vm.left.gridApi = params.api
                      }
                    }
                  }),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        float: "right",
                        margin: "5px 0"
                      }
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            no: "2",
                            type: "primary",
                            disabled: _vm.readonly
                          },
                          on: { click: _vm.addHandler }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.Add")))]
                      ),
                      _c(
                        "el-button",
                        {
                          staticStyle: { float: "right" },
                          attrs: {
                            no: "3",
                            type: "danger",
                            disabled: _vm.readonly
                          },
                          on: { click: _vm.delHandler }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.Delete")))]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "section",
                  staticStyle: { "margin-left": "10px", flex: "1" }
                },
                [
                  _c("cargo-ag-grid", {
                    staticStyle: { width: "100%", height: "350px" },
                    attrs: {
                      no: "4",
                      "grid-options": _vm.right.gridOptions,
                      "grid-params": _vm.gridParams,
                      "column-defs": _vm.rightColumnDefs,
                      "row-data": _vm.containers
                    },
                    on: {
                      "update:gridParams": function($event) {
                        _vm.gridParams = $event
                      },
                      "update:grid-params": function($event) {
                        _vm.gridParams = $event
                      },
                      gridReady: function(params) {
                        _vm.right.gridApi = params.api
                      }
                    }
                  })
                ],
                1
              )
            ]),
            _c(
              "div",
              {
                staticClass: "section",
                staticStyle: { flex: "1" },
                style: { flexDirection: "row", justifyContent: "flex-start" }
              },
              [
                _c(
                  "el-form",
                  {
                    attrs: {
                      disabled: _vm.vgmReadonly,
                      "label-width": "85px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c("el-form-item", { attrs: { "label-width": "0" } }, [
                      _c("span", [_vm._v(_vm._s(_vm.$t("SeaExport.Shipper")))]),
                      _c("span", { staticStyle: { color: "red" } }, [
                        _vm._v("（MAX:45）")
                      ])
                    ]),
                    _c(
                      "el-form-item",
                      { attrs: { "label-width": "0" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "300px" },
                          attrs: { no: "5" },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.Shipper"),
                                _vm.mergeShipperLine(),
                                _vm.splitShipperLine
                              )
                            }
                          },
                          model: {
                            value: _vm.selectedVgm.shipperLine1,
                            callback: function($$v) {
                              _vm.$set(_vm.selectedVgm, "shipperLine1", $$v)
                            },
                            expression: "selectedVgm.shipperLine1"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { "label-width": "0" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "300px" },
                          attrs: { no: "6" },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.Shipper"),
                                _vm.mergeShipperLine(),
                                _vm.splitShipperLine
                              )
                            }
                          },
                          model: {
                            value: _vm.selectedVgm.shipperLine2,
                            callback: function($$v) {
                              _vm.$set(_vm.selectedVgm, "shipperLine2", $$v)
                            },
                            expression: "selectedVgm.shipperLine2"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { "label-width": "0" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "300px" },
                          attrs: { no: "7" },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.Shipper"),
                                _vm.mergeShipperLine(),
                                _vm.splitShipperLine
                              )
                            }
                          },
                          model: {
                            value: _vm.selectedVgm.shipperLine3,
                            callback: function($$v) {
                              _vm.$set(_vm.selectedVgm, "shipperLine3", $$v)
                            },
                            expression: "selectedVgm.shipperLine3"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { "label-width": "0" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "300px" },
                          attrs: { no: "8" },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.Shipper"),
                                _vm.mergeShipperLine(),
                                _vm.splitShipperLine
                              )
                            }
                          },
                          model: {
                            value: _vm.selectedVgm.shipperLine4,
                            callback: function($$v) {
                              _vm.$set(_vm.selectedVgm, "shipperLine4", $$v)
                            },
                            expression: "selectedVgm.shipperLine4"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { "label-width": "0" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "300px" },
                          attrs: { no: "9" },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.Shipper"),
                                _vm.form.mark,
                                function(val) {
                                  _vm.form.mark = val
                                }
                              )
                            }
                          },
                          model: {
                            value: _vm.selectedVgm.shipperLine5,
                            callback: function($$v) {
                              _vm.$set(_vm.selectedVgm, "shipperLine5", $$v)
                            },
                            expression: "selectedVgm.shipperLine5"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { "label-width": "0" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "300px" },
                          attrs: { no: "10" },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.Shipper"),
                                _vm.mergeShipperLine(),
                                _vm.splitShipperLine
                              )
                            }
                          },
                          model: {
                            value: _vm.selectedVgm.shipperLine6,
                            callback: function($$v) {
                              _vm.$set(_vm.selectedVgm, "shipperLine6", $$v)
                            },
                            expression: "selectedVgm.shipperLine6"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { "label-width": "0" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "300px" },
                          attrs: { no: "11" },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.Shipper"),
                                _vm.mergeShipperLine(),
                                _vm.splitShipperLine
                              )
                            }
                          },
                          model: {
                            value: _vm.selectedVgm.shipperLine7,
                            callback: function($$v) {
                              _vm.$set(_vm.selectedVgm, "shipperLine7", $$v)
                            },
                            expression: "selectedVgm.shipperLine7"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-form",
                  {
                    staticStyle: { padding: "0 10px", "margin-top": "39px" },
                    attrs: {
                      disabled: _vm.vgmReadonly,
                      "label-width": "90px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticClass: "custom",
                        attrs: { label: _vm.$t("SeaExport.VgmContactPerson") }
                      },
                      [
                        _c("cargo-english-words-input", {
                          staticStyle: { width: "300px" },
                          attrs: { no: "12" },
                          model: {
                            value: _vm.selectedVgm.shipperContact,
                            callback: function($$v) {
                              _vm.$set(_vm.selectedVgm, "shipperContact", $$v)
                            },
                            expression: "selectedVgm.shipperContact"
                          }
                        }),
                        _c("span", { staticStyle: { color: "red" } }, [
                          _vm._v("（MAX:100）")
                        ])
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "custom",
                        attrs: {
                          label: _vm.$t("SeaExport.VgmContactEmailAddress")
                        }
                      },
                      [
                        _c("el-input", {
                          staticStyle: { width: "300px" },
                          attrs: { no: "13" },
                          model: {
                            value: _vm.selectedVgm.shipperContactEmail,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.selectedVgm,
                                "shipperContactEmail",
                                $$v
                              )
                            },
                            expression: "selectedVgm.shipperContactEmail"
                          }
                        }),
                        _c("span", { staticStyle: { color: "red" } }, [
                          _vm._v("（MAX:100）")
                        ])
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "custom",
                        attrs: { label: _vm.$t("SeaExport.VgmContactWay") }
                      },
                      [
                        _c("cargo-english-words-input", {
                          staticStyle: { width: "300px" },
                          attrs: { no: "14" },
                          model: {
                            value: _vm.selectedVgm.shipperContactWay,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.selectedVgm,
                                "shipperContactWay",
                                $$v
                              )
                            },
                            expression: "selectedVgm.shipperContactWay"
                          }
                        }),
                        _c("span", { staticStyle: { color: "red" } }, [
                          _vm._v("（MAX:100）")
                        ])
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "custom",
                        attrs: {
                          label: _vm.$t("SeaExport.VgmResponsiblePerson")
                        }
                      },
                      [
                        _c("cargo-english-words-input", {
                          staticStyle: { width: "300px" },
                          attrs: { no: "15" },
                          model: {
                            value: _vm.selectedVgm.shipperPerson,
                            callback: function($$v) {
                              _vm.$set(_vm.selectedVgm, "shipperPerson", $$v)
                            },
                            expression: "selectedVgm.shipperPerson"
                          }
                        }),
                        _c("span", { staticStyle: { color: "red" } }, [
                          _vm._v("（MAX:100）")
                        ])
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-form",
                  {
                    attrs: {
                      disabled: _vm.vgmReadonly,
                      "label-width": "90px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c("el-form-item", { staticClass: "label-none custom" }, [
                      _c("span", [_vm._v("VGM WEIGHING COMPANY")]),
                      _c("span", { staticStyle: { color: "red" } }, [
                        _vm._v("（MAX:100）")
                      ])
                    ]),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "custom",
                        attrs: { label: _vm.$t("SeaExport.ContactPerson") }
                      },
                      [
                        _c("cargo-english-words-input", {
                          staticStyle: { width: "300px" },
                          attrs: { no: "16" },
                          model: {
                            value: _vm.selectedVgm.companyContact,
                            callback: function($$v) {
                              _vm.$set(_vm.selectedVgm, "companyContact", $$v)
                            },
                            expression: "selectedVgm.companyContact"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "custom",
                        attrs: {
                          label: _vm.$t("SeaExport.ContactEmailAddress")
                        }
                      },
                      [
                        _c("cargo-english-words-input", {
                          staticStyle: { width: "300px" },
                          attrs: { no: "17" },
                          model: {
                            value: _vm.selectedVgm.companyContactEmail,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.selectedVgm,
                                "companyContactEmail",
                                $$v
                              )
                            },
                            expression: "selectedVgm.companyContactEmail"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "custom",
                        attrs: { label: _vm.$t("SeaExport.ContactWay") }
                      },
                      [
                        _c("el-input", {
                          staticStyle: { width: "300px" },
                          attrs: { no: "18" },
                          model: {
                            value: _vm.selectedVgm.companyContactWay,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.selectedVgm,
                                "companyContactWay",
                                $$v
                              )
                            },
                            expression: "selectedVgm.companyContactWay"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "custom",
                        attrs: { label: _vm.$t("SeaExport.ContactAddress") }
                      },
                      [
                        _c("cargo-english-words-input", {
                          staticStyle: { width: "300px" },
                          attrs: { no: "19" },
                          model: {
                            value: _vm.selectedVgm.companyAddress,
                            callback: function($$v) {
                              _vm.$set(_vm.selectedVgm, "companyAddress", $$v)
                            },
                            expression: "selectedVgm.companyAddress"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "custom",
                        attrs: { label: _vm.$t("SeaExport.ResponsiblePerson") }
                      },
                      [
                        _c("cargo-english-words-input", {
                          staticStyle: { width: "300px" },
                          attrs: { no: "20" },
                          model: {
                            value: _vm.selectedVgm.companyPrincipal,
                            callback: function($$v) {
                              _vm.$set(_vm.selectedVgm, "companyPrincipal", $$v)
                            },
                            expression: "selectedVgm.companyPrincipal"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "custom",
                        attrs: { label: _vm.$t("SeaExport.CompanyName") }
                      },
                      [
                        _c("cargo-english-words-input", {
                          staticStyle: { width: "300px" },
                          attrs: { no: "21", "auto-uppercase": true },
                          model: {
                            value: _vm.selectedVgm.companyName,
                            callback: function($$v) {
                              _vm.$set(_vm.selectedVgm, "companyName", $$v)
                            },
                            expression: "selectedVgm.companyName"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "el-dialog",
              {
                directives: [
                  { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
                ],
                attrs: {
                  visible: _vm.advanceTextDialog.visible,
                  title: _vm.advanceTextDialog.title,
                  width: "600px",
                  "close-on-click-modal": false,
                  "close-on-press-escape": false
                },
                on: {
                  "update:visible": function($event) {
                    return _vm.$set(_vm.advanceTextDialog, "visible", $event)
                  }
                }
              },
              [
                _c("el-input", {
                  attrs: { type: "textarea", rows: "10" },
                  model: {
                    value: _vm.advanceTextDialog.value,
                    callback: function($$v) {
                      _vm.$set(_vm.advanceTextDialog, "value", $$v)
                    },
                    expression: "advanceTextDialog.value"
                  }
                }),
                _c(
                  "span",
                  { attrs: { slot: "footer" }, slot: "footer" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { no: "22", type: "primary" },
                        on: { click: _vm.finishAdvanceText }
                      },
                      [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { no: "23" },
                        on: {
                          click: function($event) {
                            _vm.advanceTextDialog.visible = false
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }